module.exports = __webpack_public_path__ + "static/media/BENNET.da60455c.svg";